import { ServiceHandler } from 'types'
import { SERVICE_HANDLER_EXAMPLE } from './example'
import { ServiceParam } from './ServiceParam'

export const SERVICE_HANDLER: ServiceHandler<ServiceParam> = {
  ...SERVICE_HANDLER_EXAMPLE,
}
